<script lang="ts">
import { defineComponent, reactive } from 'vue'
import SuggestTags from '@/components/search/SuggestTags.vue'
import stateInitializer from '@/models/stateInitializer'

export default defineComponent({
  name: 'SearchAsideSecondary',

  components: {
    SuggestTags,
  },

  setup() {
    interface State {
      keywords: SuggestWordItem[],
    }
    const state: State = reactive({
      keywords: [],
    })
    stateInitializer(state, 'asideSecondary')

    return {
      // data
      state,
    }
  },
})
</script>

<template>
  <section
    v-if="state.keywords.length"
    class="section">
    <h2 class="h2 u-text__bold u-text__normal">
      関連用語
    </h2>
    <SuggestTags :items="state.keywords" />
  </section>
</template>

<style lang="sass" scoped>
</style>
